<template lang="html">
    <div class="form-control"
    :class="[classes, {'is-read-only': readOnly, 'is-error': errors.length}]">
      <div class="field-wrapper is-left-aligned">
        <label class="label" :for="input_uuid" v-if="label">
          {{ label }}
        </label>
        <span class="is-optional" v-if="optional"> {{ $t('components.input.optional') }}</span>
        <Tooltip
          v-if="tooltip"
          :tooltipText="tooltip"/>
        <div class="wrapper">
          <input ref="field" class="form-field"
            :type="type"
            :name="name"
            :id="input_uuid"
            :value="value"
            :autocomplete="autocomplete"
            :readonly="readOnly"
            :min="min"
            @input="$emit('input', $event.target.value)">
            <span class="information" v-if="information && !errors.length">{{ information }}</span>
            <span class="error-information" v-for="(error, index) in errors" :key="index">
              {{ error }}
            </span>
        </div>
      </div>
    </div>

</template>

<script lang="js">
import Tooltip from '@/components/Tooltip.vue';

export default {
  name: 'VqInput',
  props: {
    min: {
      type: Number,
      required: false,
    },
    label: String,
    name: String,
    information: String,
    classes: String,
    autocomplete: {
      type: String,
      default: 'off',
    },
    value: {
      type: [String, Number],
      default: '',
    },
    type: {
      type: String,
      default: 'text',
    },
    errors: {
      type: Array,
      default() { return []; },
    },
    optional: {
      type: Boolean,
      default: false,
    },
    tooltip: {
      type: String,
      required: false,
    },
    readOnly: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    Tooltip,
  },
  computed: {
    input_uuid() {
      return `${this.name}_${this.uuid}`;
    },
  },
  data() {
    return {
      uuid: Math.ceil(Math.random() * 1000),
    };
  },
};
</script>

<style scoped lang="scss">
</style>
